import { useField } from "formik";

interface PrimaryRelation {
	isPrimary: boolean;
}
export const usePrimaryRelationFieldArray = <T extends PrimaryRelation>(name: string, emptyValue: T) => {
	const [{ value: items }, , fieldHelper] = useField<T[]>(name);

	const push = (value: T) => {
		const newItems = [...items.map((item) => ({ ...item, isPrimary: !value.isPrimary && item.isPrimary })), value];
		void fieldHelper.setValue(newItems);
	};

	const replace = (index: number, value: T) => {
		const newItems = items.map((item) => ({ ...item, isPrimary: !value.isPrimary && item.isPrimary }));
		newItems[index] = value;

		void fieldHelper.setValue(newItems);
	};

	const remove = (index: number) => {
		const newItems = items.filter((_, i) => i !== index);
		if (newItems.length === 0) {
			void fieldHelper.setValue([emptyValue]);
		} else {
			void fieldHelper.setValue(newItems);
		}
	};

	return {
		items,
		push,
		replace,
		remove,
	};
};
